export class SearchResultProperty {
    key: any;
    value: any;
    highlight: string;
    constructor(key: any, value: any) {
        this.key = key;
        this.value = value;
    }
}